import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { map } from 'lodash';
import countriesStates from './countriesStates.json';

//Import Components and Styles
import  './address-table.scss';
import { Space, Row, Col, Tabs, Form, Modal,  } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import { EditOutlined, DeleteOutlined,  InboxOutlined, MoreOutlined } from '@ant-design/icons';
import { AlertBox, Button, TextInput, ImageUpload, DataTable, ActionMenu } from '@life-line-lab/components-react';
interface ModalState {
    isOpen: boolean,
    header: React.ReactNode,
    content: React.ReactNode
}

interface AddressType {
    type: string,
    street1: string,
    street2: string,
    city: string,
    postcode: string,
    state: string,
    country: string,
    defaultAddress?: boolean,

}

interface AddressListingProps {
    list: AddressType[];
    onEdit: (action: string, index: number) => void;
    onDelete: (index: number) => void;
}

const AddressList: React.FC<AddressListingProps> = ({list, onEdit, onDelete}) => {
    const { t } = useTranslation();
    const initialModal= { isOpen: false, header: null, content: null};
    const [addressList, setAddressList ] = useState<any>([{}]);
    const [selectedData, setSelectedData] = useState<any>();
    const [modalState, setModalState] = useState<ModalState>(initialModal);

    useEffect(()=>{
        setAddressList(list);
    },[list]);

    useEffect(()=>{
    },[addressList]);

    const handleModalClose = () => {
        setModalState(initialModal);
    }

    const handleDelete = (index: number) => {
        setSelectedData(index);
        setModalState({
            ...modalState,
            isOpen: true,
            header: (
                <h3 className="title">
                    {t('title.confirmDeleteAddress')}
                </h3>
            ),
            content: (
                <span>
                    {t('txt.confirmDeleteAddress')}
                </span>

            )
        })
        
    }

    const handleModalConfirm = () => {
        onDelete(selectedData);
        handleModalClose();
    }

    const handleSetAsDefault = (index: number) => {
        onEdit('DEFAULT', index);
    }

//To send 'index' (position of address in array) to profile form to manipulate
    const handleActionClick = (e: React.MouseEvent<HTMLElement>, action: 'UPDATE' | 'DELETE' | 'DEFAULT', data: AddressType) =>{
        switch (action) {
            case 'UPDATE':
                onEdit('UPDATE',addressList.indexOf(data));
                break;

            case 'DELETE':
                handleDelete(addressList.indexOf(data));
                break;

            case 'DEFAULT':
                onEdit('DEFAULT',addressList.indexOf(data));
                break;
            default:
                break;
        }
    }

//Columns for Data Table
    const columns = [
        {
            title: 'Address',
            dataIndex: ['list'],
            render:(_: any, record: any) => {return (
                <React.Fragment>
                  <div>
                    {/* <p onClick={
                      (e: React.MouseEvent<HTMLElement>) =>
                      handleActionClick(e, 'DEFAULT', record)
                    }> */}
                      <span className={record?.defaultAddress? "tag":"tag-none"}>{record?.defaultAddress? t('label.default'): ''}</span>

                     <p> {record?.street1}, <span>{record?.street2 ? record?.street2 + ', ' : ''}</span> <br/>
                      {record?.postcode}, {record?.city}, {record?.state}<br/>
                      {record?.country}</p>
                                                            
                    {/* </p> */}
                  </div>
                  <div className="meta-data">{record.address}</div>
                </React.Fragment>
              )
      
        }},
        {
            title: '',
            dataIndex: 'actions',
            render:(_: any, record: any, rowIndex: number)=>(
                <ActionMenu
                    className='address-table--action-menu'
                    label={<MoreOutlined />}
                    actions={[
                        {
                        label: t('action.setAsDefault'),
                        onClick: (e:React.MouseEvent<HTMLInputElement>) => handleActionClick(e, 'DEFAULT', record),
                        isDisable: true,    // for DEM
                        // isDisable: rowIndex === 0,
                        },
                        {
                            label: t('action.edit'),
                            icon: <EditOutlined />,
                            onClick: (e:React.MouseEvent<HTMLInputElement>) => handleActionClick(e, 'UPDATE', record)
                        },
                        {
                            label: t('action.delete'),
                            icon: <DeleteOutlined />,
                            onClick: (e:React.MouseEvent<HTMLInputElement>) => handleActionClick(e, 'DELETE', record),
                            isDisable: rowIndex === 0,
                        }
                    ]}
                />
            ),
        },
    ]

    const rowSelection = {}



    return (
        <div className="address-table">
            <Space direction="vertical" align="start">
                <div className="row">
                    <DataTable className="ant-table-cell" rowKey={(record) => {return addressList.indexOf(record);}} 
                                dataSource={addressList} columns={columns} />
                {/* {
                    addressList && map(addressList, (data: AddressType, index:number
                        ) => {
                        return (
                            <Row key={index} style={{rowGap: "10px"}}>
                                <Row style={{rowGap: "10px"}}>
                                    <span className={data?.defaultAddress? "tag":"tag-none"}>{data?.defaultAddress? t('label.default'): ''}</span>
                                    { !data?.defaultAddress?
                                    <Button
                                        className='button--default'
                                        type="secondary"
                                        size="small"
                                        isDisabled={data?.defaultAddress?true: false}
                                        label={t('label.default')}
                                        onClick={() => handleSetAsDefault(index)}
                                    /> : <></>
                                        }
                                </Row>
                                <Col style={{width: '90%', padding: '20px 0px'}} xxl={19} xl={19} lg={19} md={15} sm={15} xs={15}>
                                    <Row className="text" style={{rowGap: "10px"}}>
                                    <Col xxl={5} xl={5} lg={5} md={10} sm={10} xs={10}>
                                            <h4 className="text--left">
                                                {data?.type!='NA'?                     <>{t('label.type')}<br/></>:''}   */}
                                                {/* This part tis to check if Postcode is NA, if it's not, display "Address" as the label */}
                                                {/* {data?.postcode!='NA'?                 <>{t("label.address")}<br/><br/></>:<>{""}<br/></>}
                                                {t('label.country')}
                                            </h4>
                                        </Col>

                                        <Col xxl={12} xl={12} lg={12} md={10} sm={10} xs={10}>
                                        <h4 className="text--left"> */}

                                                {/* {data?.type!='NA'?                    <>{t(`label.${data?.type?.toLowerCase()}`)}<br/></>:''}  */}
                                                {/* {data?.postcode!='NA'?                <>{<span>{data?.street1}, <span>{data?.street2 ? data?.street2 + ', ' : ''}</span> 
                                                                                        {data?.postcode}, {data?.city}, {data?.state}<br/></span>}</> 
                                                                                        : <>{"Address Invalid"}<br/></>} */}
                                                {/* This is to adjust spacing in address */}
                                                {/* {data?.street2 && data.street2=='NA'? <>{''}<br/><br/></>:''}
                                                { map(countriesStates,(country: {name: string, code: string, states: string[]}) =>{
                                                    if(data?.country==country.name || data?.country==country.code) {
                                                        return country.name;
                                                    }
                                                })}
                                            </h4>
                                        </Col>
                                        
                                    </Row>
                                </Col>
                                <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                                    <Row>
                                        <Col xxl={12} xl={12} lg={12} md={20} sm={20} xs={20}>
                                            <EditOutlined className="editIcon svg" 
                                                        onClick={() => handleEdit(index)}
                                            />
                                        </Col>
                                        <Col xxl={12} xl={12} lg={12} md={20} sm={20} xs={20}>
                                            {!data?.defaultAddress? 
                                                <Button
                                                    isDisabled={data?.defaultAddress? true: false}
                                                    className='button--delete'
                                                    type="secondary"
                                                    size="small"
                                                    icon={<DeleteOutlined />}
                                                    onClick={() => handleDelete(index)}
                                                />:<></>
                                            }
                                           
                                        </Col>
                                    </Row>

                                </Col>

                                <hr />

                            </Row>
                        )
                    })
                } */}

                    {
                        !addressList && <Space style={{width: '22%'}} direction="horizontal" size="large">
                        <Avatar style={{backgroundColor: '#cac2c2', display: 'flex', justifyContent: 'center', alignItems: 'center'}} icon={<InboxOutlined />} size="large" />
                        <h3 style={{fontFamily: 'Mulish',  color: '#cac2c2'}}>{t('txt.noAddresses')}</h3>
                    </Space>
                    }
                </div>
            </Space>
            <Modal visible={modalState.isOpen} onOk={handleModalConfirm} onCancel={handleModalClose}>
                { modalState.header  }
                { modalState.content }
            </Modal>
        </div>
    );
}

export default AddressList;
